import React, { useEffect, useState } from "react"

import { Link } from "gatsby"

import { Icon } from "@components/icon"
import { numProductsInCart } from "@services/actions/product-actions"

import * as styles from "./basket.module.css"

const Basket = ({ location }) => {
  const [numProducts, setNumProducts] = useState(0)

  const fetchNumProducts = async () => {
    const numProducts = await numProductsInCart()
    setNumProducts(numProducts)
  }

  useEffect(() => {
    fetchNumProducts()
  }, [location])

  return (
    // The only visible text in this link is the item count (styles.text is
    // display:none), so the accessible name has to contain that count —
    // otherwise the name overrides the visible label and they mismatch.
    <Link
      to="/shoppingcart"
      className={styles.container}
      aria-label={`Basket, ${numProducts} ${
        numProducts === 1 ? "item" : "items"
      }`}
    >
      <Icon id="cart-shopping" width="20" height="20" className={styles.icon} />
      <div className={styles.batch}>
        <span className="mb-auto mt-auto">{numProducts}</span>
      </div>
      <span className={styles.text}>Basket</span>
    </Link>
  )
}

export default Basket
